import { render, staticRenderFns } from "./FiltroModulos.vue?vue&type=template&id=492ed071&"
import script from "./FiltroModulos.vue?vue&type=script&lang=js&"
export * from "./FiltroModulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports